import { Environment } from '@sasser/sfh-shared-security';

export const environment = {
  production: false,
  name: 'QA',
  security: Environment.QA,
  empowerAi: {
    apiBaseUrl: 'https://api-sfh-enterpriseai-test.azurewebsites.net/api',
    businessUnit: 'ChicagoFreightCar',
    appRegKey: 'a481aec1-cf0b-46c8-9f13-295dc0eff75f'
  }
};
